/**
 * Creates an empty label value object
 * @return {LabelValue}
 */
export const emptyLabelValue = () => {
    return {
        label: '',
        value: '',
    };
};

/**
 * Check if an object contains a label and a value property, this is format is used for a lot of property in the PR
 * @param {object} obj
 * @return {{label: string, value: string}}
 */
export const checkLabelValueObject = (obj) => {
    if (!obj) { // if object is undefined, return an empty label/value object
        return emptyLabelValue();
    } else if (typeof obj === 'string' || obj instanceof String) {
        if (obj.includes(' - ')) { // if obj is a simple string, and contains ' - ' return label/value object with first path as value and the whole string as label.
            return {
                label: obj,
                value: obj.split(' - ')[0],
            };
        } else { // Otherwise, return label/value object with the entire string in value and label properties
            return {
                label: obj,
                value: obj,
            };
        }
    } else if (!('label' in obj) || !('value' in obj)) { // if label or value isn't in obj, return empty label/value object, but keep the already defined part.
        return {
            label: 'label' in obj ? obj.label : '',
            value: 'value' in obj ? obj.value : '',
        };
    } else { // else (if there is label and value in the object, return an object only with these two properties
        return {
            label: obj.label,
            value: obj.value,
        };
    }
};

/**
 * Create a LabelValue object from 2 parameters
 * @param {string} label
 * @param {any} value
 * @return {LabelValue}
 */
export const createLabelValue = (label, value) => {
    return {
        label: label,
        value: value,
    };
};

/**
 *
 * @param {LabelValue} a
 * @param {LabelValue} b
 * @return {boolean}
 */
export const isLabelValueIdentical = (a, b) => {
    return a.value === b.value &&
        a.label === b.label;
};

/**
 *
 * @param {LabelValue} labelValue
 * @return {boolean}
 */
export const isLabelValueEmpty = (labelValue) => {
    return !labelValue || !labelValue.value;
};

/**
 * Check if the parameter is a Label Value object
 * @param {*} value
 * @return {boolean}
 */
export const isLabelValue = (value) => {
    return value && (typeof value === 'object' && 'label' in value && 'value' in value);
};

/**
 * Parse a string in the format `US16 - Nestle USA Inc.` or a LabelValue object and returns only the code (eg: `US16`)
 * @param {string | LabelValue} labelValueStringOrObject
 * @return {string}
 */
export const getValueFromLabelValue = (labelValueStringOrObject) => {
    if (!labelValueStringOrObject) {
        return '';
    }
    if (typeof labelValueStringOrObject === 'string') {
        return labelValueStringOrObject.split(' - ')[0].trim();
    } else if (typeof labelValueStringOrObject === 'object') {
        if (typeof labelValueStringOrObject.value === 'string') {
            return labelValueStringOrObject.value.trim();
        } else if (typeof labelValueStringOrObject.value === 'number') {
            return labelValueStringOrObject.value.toString().trim();
        }
    }
    return '';
};
